import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
class SettingsHeartRunnerComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alarmJson: '',
            MissionId: '',
            autoSyncUserTime : ''
        }
        this.basestate = this.state;
        //this.addDeviceDetails = this.addDeviceDetails.bind(this);
    }

    /* componentDidMount() {
         this.validator = new SimpleReactValidator();
     }*/
    componentDidMount() {
        if (localStorage.getItem('alarmJSON')) {
            this.state.alarmJson = localStorage.getItem('alarmJSON');
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.details.statusCode !== this.props.details.statusCode) {

            if (nextProps.details.messageLabel !== "") {
                if (nextProps.details.statusCode == 409) {
                    swal(nextProps.details.errorMessage)

                }
                else if(nextProps.details.statusCode == 200) {
                    if(nextProps.details.errorMessage == '' || nextProps.details.errorMessage == null || nextProps.details.errorMessage == undefined){
                        swal(nextProps.details.messageLabel)
                    }
                    else {
                        swal(nextProps.details.errorMessage)
                    }
                    this.setState({MissionId : ''});
                }
                else{
                    swal(nextProps.details.errorMessage) 
                }

            }
        }
        this.setState({autoSyncUserTime : nextProps.details.autoSyncUserTime})
    }

    componentWillMount() {
        this.validator = new SimpleReactValidator();
    }


    errornotify = (message) => {
        toast.error(message + "!", {
            position: toast.POSITION.TOP_CENTER
        });


    };
    successnotify = (message) => {
        toast.success(message + "!", {
            position: toast.POSITION.TOP_CENTER
        });
    };
    handleInput = (e) => {
        let value = e.target.value;
        let name = e.target.name;

        this.setState({ [name]: value })
    }
    syncUser = () => {
        this.props.syncUser();
    }
    syncSetting = () => {
        this.props.syncSetting();
    }
    syncLocation = () => {
        this.props.syncLocation();
    }
    insertAlarmJSON = () => {
        const { t } = this.props;
        if (this.state.alarmJson.length > 0) {
            try{
                JSON.parse(this.state.alarmJson)
                this.props.insertAlarmJSON(this.state.alarmJson)
                localStorage.setItem('alarmJSON', this.state.alarmJson)
            }
            catch{
                swal('JSON Invalid')
            }
        }
        else {
            swal(`${t('Setting.Please enter Alarm JSON')}`)
        }
    }
    copyAlarmJSON = () => {
        let json = {
            "MissionId": "20220118-1300-001",
            "Street": "Hornsgatan",
            "Floor": "5",
            "City": "Södermalm",
            "PosLat": "29.1327762",
            "PosLon": "78.265017",
            "Municipality": "Hänvisning",
            "Country": "India",
            "FirstName": "Haidar",
            "LastName": "Ali",
            "Description": "PK:123, Namn på dörren:Haidar Ali, Ni måste ringa innan",
            "WhiteList": [
            "Ligger på innegården mitt"
            ],
            "Phone": [
            "9876543211"
            ],
            "ZipCode": "201301",
            "AlarmCategory": "Hjärtstopp",
            "CaseType": "Allergisk reaktion"
            }
            this.setState({alarmJson : JSON.stringify(json, null, '\t')});
    }
    missionAbort = () => {
        const { t } = this.props;
        if (this.state.MissionId.length > 0) {
            this.props.abortAlarmMission(this.state.MissionId);
        }
        else {
            swal(`${t('Setting.Please enter the mission id')}`);
        }
    }
    saveSyncTime = () => {
        let payload = {
            "SettingValue" : this.state.autoSyncUserTime
        }
        this.props.updateSyncTimeData(payload)
    }
    render() {
        const { t } = this.props;
        let isActive = this.props.details.isLoading
        let isActiveSetting = this.props.details.isLoadingSetting
        let isActiveSyncUser = this.props.details.isLoadingSyncUser
        let isActiveSyncLocation = this.props.details.isLoadingSyncLocation
        let isActiveAbortMission = this.props.details.isLoadingAbortMission
        let isActiveAutoSyncUserTime = this.props.details.isLoadingSyncUserTime
        return (
            <div >
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Setting.Settings')}</h2>
                </div>

                <div className="panel panel-widget forms-panel w3-last-form setting-layout">

                    <div className=" forms add-device setting-panel">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">

                                <ToastContainer />
                                <form className="form-horizontal">
                                    <div className="form-group">
                                        <div className="row settings-css">
                                            <div className="col-md-6">
                                                <label className="control-label">{t('Setting.Sync Users with dispatcher')}</label>
                                                <div className="">
                                                    <div className="input-group">
                                                        {!isActiveSyncUser ?
                                                            <button type="button" className="sync-usr-btn btn btn-primary" onClick={() => { this.syncUser() }}>{t('Setting.Sync User')}</button>
                                                            : <button type="button" className="btn btn-primary"><i className="fa fa-spinner fa-spin" style={{ fontSize: '36px' }}></i></button>

                                                        }

                                                    </div>

                                                </div>

                                                <label className="msn-abrt control-label">{t('Setting.Set time for auto synchronization user (in minutes)')}</label>
                                                <div className="">
                                                    <div className="input-group">
                                                        <input
                                                            className="contact-input"
                                                            type="number"
                                                            name={'autoSyncUserTime'}
                                                            onChange={this.handleInput}
                                                            value={this.state.autoSyncUserTime}
                                                        />
                                                    </div>
                                                    <div>
                                                    {/* <button type="button" className="sync-usr-btn btn btn-primary" 
                                                        onClick={() => { this.saveSyncTime() }}>Save Time</button> */}
                                                        {/* <button type="button" className="btn btn-primary sync-usr-btn"
                                                            onClick={() => { this.missionAbort() }}
                                                        >{t('Setting.Mission Abort')}</button> */}
                                                        {!isActiveAutoSyncUserTime ?
                                                            <button type="button" className="sync-usr-btn btn btn-primary" onClick={() => { this.saveSyncTime() }}>{t('Setting.Save Time')}</button>
                                                            : <button type="button" className="btn btn-primary"><i className="fa fa-spinner fa-spin" style={{ fontSize: '36px' }}></i></button>

                                                        }
                                                    </div>
                                                </div>

                                                <br></br>
                                                
                                                <label className="control-label">{t('Setting.Sync Setting')}</label>
                                                <div className="">
                                                    <div className="input-group">
                                                        {!isActiveSetting ?
                                                            <button type="button" className="sync-usr-btn btn btn-primary" onClick={() => { this.syncSetting() }}>{t('Setting.Sync Setting')}</button>
                                                            : <button type="button" className="btn btn-primary"><i className="fa fa-spinner fa-spin" style={{ fontSize: '36px' }}></i></button>

                                                        }
                                                    </div>
                                                </div>


                                                {/* <label className="control-label">Sync Kit Location</label>
                                                <div className="">
                                                    <div className="input-group">
                                                        {!isActiveSyncLocation ?
                                                            <button type="button" className="sync-usr-btn btn btn-primary" onClick={() => { this.syncLocation() }}>Sync Location</button>
                                                            : <button type="button" className="btn btn-primary"><i className="fa fa-spinner fa-spin" style={{ fontSize: '36px' }}></i></button>

                                                        }
                                                    </div>
                                                </div> */}


                                                <label className="msn-abrt control-label">{t('Setting.Mission Abort')}</label>
                                                <div className="">
                                                    <div className="input-group">
                                                        <input type="text"
                                                            name="MissionId"
                                                            onChange={this.handleInput}
                                                            value={this.state.MissionId}
                                                            placeholder={t('Setting.Mission Id')}
                                                            className="missing-abrt-input"
                                                        />
                                                    </div>
                                                    <div>
                                                        {/* <button type="button" className="btn btn-primary sync-usr-btn"
                                                            onClick={() => { this.missionAbort() }}
                                                        >{t('Setting.Mission Abort')}</button> */}
                                                        {!isActiveAbortMission ?
                                                            <button type="button" className="sync-usr-btn btn btn-primary" onClick={() => { this.missionAbort() }}>{t('Setting.Mission Abort')}</button>
                                                            : <button type="button" className="btn btn-primary"><i className="fa fa-spinner fa-spin" style={{ fontSize: '36px' }}></i></button>

                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">

                                                <label className="control-label">{t('Setting.Insert Alarm')}</label>
                                                <div className="">
                                                    <div className="input-group">

                                                        <textarea
                                                            name="alarmJson"
                                                            onChange={this.handleInput}
                                                            value={this.state.alarmJson}
                                                            //className="form-control1"
                                                            placeholder={t('Setting.Please insert Alarm JSON')}
                                                            rows="12" cols="70"
                                                            className="insert-laram-textarea"
                                                        >
                                                        </textarea>

                                                    </div>

                                                </div>
                                                <div className="">
                                                    <div className="input-group">
                                                        {!isActive ?
                                                            <button type="button" className="btn btn-primary" onClick={() => { this.insertAlarmJSON() }}>{t('Setting.Insert')}</button>
                                                            :
                                                            <button type="button" className="btn btn-primary"><i className="fa fa-spinner fa-spin" style={{ fontSize: '36px' }}></i></button>
                                                        }
                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                        <button type="button" className="btn btn-primary" onClick={() => { this.copyAlarmJSON() }}>{t('Setting.Copy')} JSON</button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default withNamespaces()(withRouter(SettingsHeartRunnerComponent));

